/* eslint-disable valid-typeof */
import React, { Component } from 'react';
import './breadcrumb-lista.css';
import { withTranslation } from 'react-i18next';
import GeoClient from '../../api/destinations';
import Buscador from '../buscadores/form-buscador-reusable';

import Common from '../../commons/commons';

const getParams = () => {
  if (!global.expressLocation && typeof 'window' === undefined) {
    return {
      origin: '',
      destination: '',
      month: '',
      distribution: '',
      since: '',
      until: '',
    };
  }
  const { pathname, search, host } = Common.getLocationInformation();
  return {
    href: `https://${host}${pathname}${search}`,
    host,
    pathname,

  };
};

class Breadcrumb extends Component {
  constructor(props) {
    super(props);
    this.state = {
      origin: this.props.origin,
      destination: this.props.destination,
      showSearcher: false,
    };
    this.setDestination = this.setDestination.bind(this);
    this.setOrigin = this.setOrigin.bind(this);
  }

  componentDidMount() {
    if (this.state.origin) this.setOrigin();

    if (this.state.destination) this.setDestination();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.origin !== this.props.origin) {
      if (this.props.origin) this.setOrigin();
    }
    if (prevProps.destination !== this.props.destination) {
      if (this.props.destination) this.setDestination();
    }
  }

  setDestination() {
    GeoClient.getCityByCode(this.props.destination).then((res) => {
      this.setState({
        destination: res.name,
      });
    });
  }

  setOrigin() {
    GeoClient.getCityByCode(this.props.origin).then((res) => {
      this.setState({
        origin: res.name,
      });
    });
  }

  toggleSearcher = () => {
    this.setState((prevState) => ({
      ...prevState,
      showSearcher: !prevState.showSearcher,
    }));
  }

  render() {
    const { t } = this.props;
    const { showSearcher } = this.state;
    const { href, host } = getParams();
    return (
      <div className='breadcrumb-panel-paquete-container'>
        <div className='container breadcrumb-panel-paquete'>
          <div className='flex flex-col md:flex-row justify-center items-center py-4 md:py-4'>
            <ul className='breadcrumb-lista text-center mb-3 mr-0 md:mr-3 md:mb-0'>
              <li><a href='/'>{host}</a></li>
              <li><a href={process.env.RAZZLE_URL}>{t('sections.packages')}</a></li>
              <li>
                <a href={href}>
                  {t('packages_list.packages_to', { destination: this.state.destination })}
                </a>
              </li>
              <li className='active'>
                <span className='breadcrum-text'>
                  {t('packages_list.packages_breadcrumb_text', {
                    destination: this.state.destination,
                    origin: this.state.origin,
                    date: this.props.searchMonth,
                  })}
                </span>
              </li>
            </ul>
            <button
              type='button'
              onClick={this.toggleSearcher}
              className='px-3 py-1 flex items-center justify-center text-white font-medium border rounded-lg'
            >
              <div>{t('packages_list.modify_search')}</div>
            </button>
          </div>
          <div className={showSearcher ? 'flex py-4' : 'hidden'}>
            {typeof window === 'undefined' ? null : (
              <Buscador
                isInList={true}
                idUnico='searcher-breadcrum'
              />
            )}
          </div>
        </div>
      </div>

    );
  }
}

export default withTranslation()(Breadcrumb);
